import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18cf55a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weCom_Box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "wx_reg" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref, provide, reactive, onBeforeMount} from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 绑定企业微信
  'GET/oauth2': oauthApi,
  // logout
  'POST/logout': loginOutApi,
  // 判断测试和生产环境
  'GET/application/info': applicationInfoApi,
} = Api
const store = useStore()
const route = useRoute()

const weComFg = ref<boolean>(false)
const environmentTip = ref<boolean>(false)
let wwLogin: any

onBeforeMount(() => {
  store.commit('SET_TOKEN', route.params.token)
  applicationInfoApi().then((rep) => {
    // CO3-Dev ---> 测试环境
    let { name } = rep
    environmentTip.value =  name === 'CO3-Dev' ? true : false
  })
  oauthApi()
    .then(rep => {
      if(rep.show){
        // 未绑定
        weComFg.value = false
        return new Promise((resolve, reject) => {
          // @see: https://stackoverflow.com/questions/8578617
          let scriptEle = document.createElement("script");
          scriptEle.type = "text/javascript";
          scriptEle.async = false;
          scriptEle.src = "https://wwcdn.weixin.qq.com/node/wework/wwopen/js/wwLogin-1.2.7.js";
          // scriptEle.onload = resolve;
          scriptEle.addEventListener("load", () => resolve(rep));
          scriptEle.addEventListener("error", e => {
              console.log(e.error)
              reject(e.error)
          });
          document.head.appendChild(scriptEle);
        })
      }
      weComFg.value = true

    })
    .then((rep: any) => {
      wwLogin = new WwLogin({
        // "self_redirect": true,
        "id": "wx_reg", 
        "appid": rep.appid,
        "agentid": rep.agentId,
        "redirect_uri": rep.redirectUrl,
        "state": rep.state,       
      })
    })
})

// 绑定企业微信
const bindFg = ref<boolean>(false)
const bindCallback = async() => {
  bindFg.value = true
  let { show } = await oauthApi()
  bindFg.value = false
  if(show){
    // 未绑定成功
    ElMessage.warning('未绑定成功')
    return
  }
  ElMessage.success('绑定成功')
  weComFg.value = true
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})